/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./index.css";

// Components Imports
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import useCategories from "../../../utils/useCategories";
import IconTearDropButton from "../../_utils/CommonButtons/IconTearDropButton";
import PrimaryButton from "../../_utils/CommonButtons/PrimaryButton";
import CommonCalendar from "../../_utils/CommonCalendar";
import SingleSelectDropDownComponent from "../../_utils/CommonDropdown/SingleSelectDropdown";
import TextInputField from "../../_utils/CommonInputFields/TextInputField";
import SVGComponent from "../../_utils/SVGComponent";

const MisCreateFilter = (props) => {
  useCategories();

  const [columnstate, setColumnState] = useState("");
  const [isUserTyping, setIsUserTyping] = useState(false);
  const [startDate, setStartDate] = useState(null);

  const { beneTransCategories } = useSelector(
    (state) => state.beneAllVerification,
  );

  console.log("attem");

  const selectedColumns = props?.columnsData
    ?.filter((col) => col.selected)
    ?.map((itm) => itm.columnName);

  // Helper function to convert date to YYYY-MM-DD format (for backend)
  const formatDateToYYYYMMDD = (date) => {
    if (!date) return "";
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Helper function to parse YYYY-MM-DD string to Date object
  const parseYYYYMMDDToDate = (dateString) => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split("-");
    return new Date(year, month - 1, day);
  };

  const handleDateChange2 = (date) => {
    setStartDate(date);

    if (date) {
      const dateInYYYYMMDD = formatDateToYYYYMMDD(date);
      let data = props?.filterMapping.map((itm, idx) => {
        if (idx === props?.activeTab) {
          return {
            ...itm,
            input_value: dateInYYYYMMDD,
            active: false,
          };
        } else {
          return itm;
        }
      });
      props?.setFilterMapping(data);
    } else {
      let data = props?.filterMapping.map((itm, idx) => {
        if (idx === props?.activeTab) {
          return {
            ...itm,
            input_value: "",
          };
        } else {
          return itm;
        }
      });
      props?.setFilterMapping(data);
    }
  };

  const allowedNameInput = (value) => {
    if (value?.length >= GlobalConfiguration?.inputValidationLength)
      return false;
    return true;
  };

  const handleInput = (e) => {
    let { value } = e.target;
    if (allowedNameInput(value)) {
      let data = props?.filterMapping.map((itm, idx) => {
        if (idx === props?.activeTab) {
          return {
            ...itm,
            input_value: value?.toUpperCase(),
            active: false,
          };
        } else {
          return itm;
        }
      });
      props?.setFilterMapping(data);
    }
  };

  const handleAmount = (value) => {
    setIsUserTyping(true);

    // Clear typing state after user stops typing
    setTimeout(() => {
      setIsUserTyping(false);
    }, 1500);

    if (value[0] !== 0 || props?.selectedOption === "User") {
      const sanitizedText = value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1");
      const amount = parseFloat(sanitizedText);

      if (sanitizedText.length !== "" && !isNaN(amount)) {
        if (
          props?.selectedOption === "User" &&
          value[0] === "0" &&
          value.length > 1
        )
          return;
        if (value.includes(".") && value.length > 12) return;
        if (!value.includes(".") && value.length > 9) return;
        const regex = /^\d*\.?\d{0,2}$/;

        if (regex.test(value)) {
          let data = props?.filterMapping.map((itm, idx) => {
            if (idx === props?.activeTab) {
              return {
                ...itm,
                input_value: value?.toUpperCase(),
                active: false,
              };
            } else {
              return itm;
            }
          });
          props?.setFilterMapping(data);
        }
      } else {
        let data = props?.filterMapping.map((itm, idx) => {
          if (idx === props?.activeTab) {
            return {
              ...itm,
              input_value: "",
              //  active: false,
            };
          } else {
            return itm;
          }
        });
        props?.setFilterMapping(data);
      }
    }
  };

  const renderField = (filter = null, currentIndex = null) => {
    let data = beneTransCategories?.categories?.map((itm) => {
      return itm.name;
    });

    const currentColumn = filter?.column_name || "";

    // Don't render anything if no column is selected
    if (!currentColumn || currentColumn === "") {
      return null;
    }

    switch (currentColumn) {
      case "Amount":
        return (
          <div
            className="Mis_report_filter_inputUser"
            style={{
              opacity:
                props?.activeTab !== currentIndex
                  ? "var(--light-opacity)"
                  : "var(--base-opacity)",
            }}
          >
            <TextInputField
              bgColor="var(--primary-card)"
              fgColor="var(--text-secondary)"
              placeholder="Detail"
              variant={"default"}
              fontKind="small"
              value={filter?.input_value || ""}
              onInput={(e) => handleAmount(e.target.value)}
              disabled={props?.activeTab !== currentIndex}
            />
          </div>
        );

      case "Account statement entry date":
        return (
          <div
            className="w-full"
            style={{
              opacity:
                props?.activeTab !== currentIndex
                  ? "var(--light-opacity)"
                  : "var(--base-opacity)",
              pointerEvents:
                props?.activeTab !== currentIndex ? "none" : "auto",
            }}
          >
            <CommonCalendar
              startDate={startDate}
              handleDateChange={handleDateChange2}
              type="big"
              selectionType="single"
            />
          </div>
        );
      case "Entity ID":
        return (
          <div
            className="Mis_report_filter_inputUser"
            style={{
              opacity:
                props?.activeTab !== currentIndex
                  ? "var(--light-opacity)"
                  : "var(--base-opacity)",
            }}
          >
            <TextInputField
              bgColor="var(--primary-card)"
              fgColor="var(--text-secondary)"
              placeholder="Detail"
              variant={"default"}
              fontKind="small"
              value={filter?.input_value || ""}
              onInput={handleInput}
              disabled={props?.activeTab !== currentIndex}
            />
          </div>
        );

      case "User name":
      case "Account Id":
        return (
          <div
            className="Mis_report_filter_inputUser"
            style={{
              opacity:
                props?.activeTab !== currentIndex
                  ? "var(--light-opacity)"
                  : "var(--base-opacity)",
            }}
          >
            <TextInputField
              bgColor="var(--primary-card)"
              fgColor={"var(--text-secondary"}
              placeholder="Detail"
              variant={"default"}
              fontKind="small"
              value={filter?.input_value || ""}
              onInput={handleInput}
              disabled={props?.activeTab !== currentIndex}
            />
          </div>
        );

      case "Distribution remark":
        return (
          <div
            className="Mis_report_filter_inputUser"
            style={{
              opacity:
                props?.activeTab !== currentIndex
                  ? "var(--light-opacity)"
                  : "var(--base-opacity)",
            }}
          >
            <TextInputField
              bgColor="var(--primary-card)"
              fgColor="var(--text-secondary)"
              placeholder="Detail"
              variant={"default"}
              fontKind="small"
              value={filter?.input_value || ""}
              onInput={handleInput}
              disabled={props?.activeTab !== currentIndex}
            />
          </div>
        );

      case "Confidential transaction":
        return null;

      case "Beneficiary account created":
      case "Beneficiary transaction created":
      case "Beneficiary transaction approved":
      case "Internal transaction created":
      case "Internal transaction approved":
        return (
          <div
            className="Mis_report_filter_inputUser"
            style={{
              opacity:
                props?.activeTab !== currentIndex
                  ? "var(--light-opacity)"
                  : "var(--base-opacity)",
            }}
          >
            <TextInputField
              bgColor="var(--primary-card)"
              fgColor="var(--text-secondary)"
              placeholder="Detail"
              variant={"default"}
              fontKind="small"
              value={filter?.input_value || ""}
              onInput={(e) => handleAmount(e.target.value)}
              disabled={props?.activeTab !== currentIndex}
            />
          </div>
        );

      case "Opening balance":
      case "Closing balance":
        return (
          <div className="">
            <TextInputField
              bgColor="var(--Blue-3)"
              fgColor={"var(--text-secondary"}
              placeholder="Detail"
              variant={"default"}
              fontKind="small"
              value={filter?.input_value || ""}
              onInput={(e) => handleAmount(e.target.value)}
              disabled={props?.activeTab !== currentIndex}
            />
          </div>
        );

      default:
        return (
          <div className=" w-full Qsmd:w-options-width flex flex-col justify-center items-start gap-y-gap-xs h-fit">
            <SingleSelectDropDownComponent
              options={
                currentColumn === "Amount"
                  ? ["Minimum", "Maximum", "Include", "Exclude"]
                  : currentColumn === "Approval status"
                    ? [
                        "all",
                        "approved",
                        "pending",
                        "rejected",
                        "abandoned",
                        "blocked",
                      ]
                    : currentColumn === "Distribution status"
                      ? [
                          "all",
                          "distribution complete",
                          "distribution created",
                          "distribution approved",
                          "awaiting funds",
                          "distribution initiated",
                          "distribution pending",
                          "distribution rejected",
                          "distribution failed",
                          "distribution reversal",
                          "distribution denied",
                          "distribution abandoned",
                        ]
                      : currentColumn === "Payment method"
                        ? ["NEFT", "RTGS"]
                        : currentColumn === "Category"
                          ? data
                          : ["Include", "Exclude"]
              }
              selected={filter?.input_value || ""}
              setSelected={(value) => {
                let data = props?.filterMapping.map((itm, idx) => {
                  if (idx === props?.activeTab) {
                    return {
                      ...itm,
                      input_value: value,
                    };
                  } else {
                    return itm;
                  }
                });
                props?.setFilterMapping(data);
              }}
              type="small"
              showSearch={false}
              placeholder="Select"
              searchPlaceholder=""
              disabled={props?.activeTab !== currentIndex}
            />
          </div>
        );
    }
  };

  useEffect(() => {
    const { activeTab, filterMapping, setFilterMapping, setActiveTab } = props;

    if (activeTab !== null) {
      const currentFilter = filterMapping[activeTab];
      if (currentFilter && currentFilter.active) {
        const hasColumn =
          currentFilter.column_name && currentFilter.column_name.length > 0;
        const hasCriteria =
          currentFilter.criteria_name && currentFilter.criteria_name.length > 0;
        const hasInput =
          currentFilter.input_value !== "" &&
          currentFilter.input_value !== null &&
          currentFilter.input_value !== undefined;
        const isConfidentialTransaction =
          currentFilter.column_name === "Confidential transaction";

        if (
          !isUserTyping &&
          hasColumn &&
          hasCriteria &&
          (hasInput || isConfidentialTransaction)
        ) {
          setTimeout(() => {
            let data = filterMapping.map((itm, idx) => {
              if (idx === activeTab) {
                return {
                  ...itm,
                  active: false,
                };
              } else {
                return itm;
              }
            });
            setFilterMapping(data);
            setColumnState("");
            setActiveTab(null);
          }, 1000);
        }
      }
    }
  }, [
    props.filterMapping,
    props.activeTab,
    isUserTyping,
    props.setFilterMapping,
    props.setActiveTab,
  ]);

  useEffect(() => {
    if (columnstate) {
      setStartDate(null);
    }
  }, [columnstate]);

  // Restore date when editing existing filter
  useEffect(() => {
    const { activeTab, filterMapping } = props;
    if (activeTab !== null && filterMapping[activeTab]) {
      const currentFilter = filterMapping[activeTab];
      if (currentFilter.column_name === "Account statement entry date") {
        // If there's a saved date value in YYYY-MM-DD format, parse it back to a Date object
        if (currentFilter.input_value && currentFilter.input_value !== "") {
          const parsedDate = parseYYYYMMDDToDate(currentFilter.input_value);
          setStartDate(parsedDate);
        } else {
          setStartDate(null);
        }
      } else {
        // Reset date state if column is not Account statement entry date
        setStartDate(null);
        // setShowDatePicker(false); // Commented out - CommonCalendar manages visibility
      }
    }
  }, [props.activeTab, props.filterMapping]);

  return (
    <>
      <div className={`Mis_report_Main_div px-padding-md lg:px-padding-base`}>
        <div className="Mis_report_filter_SelectAcc_div">
          <div
            onClick={() => {
              if (
                props?.filterMapping.every((itm) => {
                  return itm.active === false;
                }) &&
                selectedColumns &&
                selectedColumns.length > 0
              ) {
                props?.setFilterMapping((prev) => {
                  return [
                    ...prev,
                    {
                      active: true,
                      column_name: "",
                      criteria_name: "",
                      input_value: "",
                    },
                  ];
                });
                props?.setActiveTab(props?.filterMapping.length);
              }
            }}
            className={`Mis_report_filter_name ${
              props?.filterMapping.every((itm) => {
                return itm.active === false;
              }) &&
              selectedColumns &&
              selectedColumns.length > 0
                ? "global-hover-white cursor-pointer"
                : "cursor-default opacity-light-opacity"
            } `}
          >
            <div className="w-full flex flex-col justify-center items-center gap-y-gap-xs h-fit">
              <SVGComponent
                url={
                  "https://q2pay.in/new_assets/common/settings/add_button_white.svg"
                }
                color="var(--text-primary)"
                height={"var(--icon-lg)"}
                width={"var(--icon-lg)"}
              />
              <p className="font-semibold text-font-sm  text-text-primary">
                Add filter
              </p>
            </div>
          </div>
          {props?.filterMapping?.length > 0 && (
            <>
              {props?.filterMapping.map((filter, index) => {
                return (
                  <div
                    style={{
                      backgroundColor: "var(--primary-card)",
                    }}
                    className="Mis_report_filter_name relative"
                  >
                    <div
                      className={`${
                        (props?.filterMapping.every((itm) => {
                          return itm.active === false;
                        }) &&
                          selectedColumns &&
                          selectedColumns.length > 0) ||
                        props?.activeTab === index
                          ? "cursor-pointer"
                          : "cursor-default opacity-light-opacity pointer-events-none"
                      } absolute top-0 right-0 rounded-bl-border-radius-md rounded-tr-border-radius-md flex`}
                    >
                      <IconTearDropButton
                        handleFunction={() => {
                          let data = props?.filterMapping.filter(
                            (item, idx) => {
                              return idx !== index;
                            },
                          );
                          props?.setFilterMapping(data);
                        }}
                        isDisabled={false}
                        isLoading={false}
                        enabledBgColor={"var(--primary-nav-act)"}
                        icon={
                          "https://q2pay.in/new_assets/common/create_flow/delete_white_filled.svg"
                        }
                        hoverOption="white"
                        title="Delete"
                      />
                    </div>
                    <div className="w-full flex flex-col gap-y-gap-xs h-fit">
                      <p className="font-semibold text-font-md text-text-primary">
                        Filter By{" "}
                        <span className=" font-semibold">(Optional)</span>
                      </p>
                      <p className="text-font-xs h-fit text-text-secondary">
                        MIS report will be filtered based on the fields selected
                        below.
                      </p>
                    </div>
                    <div className="Mis_report_filter_main">
                      <div className="w-options-width flex flex-col justify-center items-start gap-y-gap-xs h-fit">
                        <p className="text-font-xs  text-text-secondary text-left">
                          Column
                        </p>
                        <SingleSelectDropDownComponent
                          options={selectedColumns || []}
                          selected={props?.filterMapping[index]?.column_name}
                          setSelected={(val) => {
                            setColumnState(val);
                            let data = props?.filterMapping.map((itm, idx) => {
                              if (idx === props?.activeTab) {
                                return {
                                  ...itm,
                                  column_name: val,
                                  input_value: "",
                                };
                              } else {
                                return itm;
                              }
                            });
                            props?.setFilterMapping(data);
                          }}
                          type="small"
                          showSearch={false}
                          placeholder="Select"
                          searchPlaceholder=""
                          disabled={props?.activeTab !== index}
                        />
                      </div>
                      <div className="w-options-width flex flex-col justify-center items-start gap-y-gap-xs h-fit">
                        <p className="text-font-xs  text-text-secondary text-left">
                          Criteria
                        </p>
                        <div className="w-full">
                          <SingleSelectDropDownComponent
                            options={
                              columnstate === "Amount" ||
                              columnstate === "Opening balance" ||
                              columnstate === "Closing balance" ||
                              props?.filterMapping[index]?.column_name ===
                                "Amount" ||
                              props?.filterMapping[index]?.column_name ===
                                "Opening balance" ||
                              props?.filterMapping[index]?.column_name ===
                                "Closing balance"
                                ? ["Minimum", "Maximum", "Include", "Exclude"]
                                : columnstate ===
                                      "Account statement entry date" ||
                                    props?.filterMapping[index]?.column_name ===
                                      "Account statement entry date"
                                  ? ["Include"]
                                  : props?.selectedOption === "User" &&
                                      columnstate !== "User name"
                                    ? [
                                        "Minimum",
                                        "Maximum",
                                        "Include",
                                        "Exclude",
                                      ]
                                    : ["Include", "Exclude"]
                            }
                            selected={
                              props?.filterMapping[index]?.criteria_name
                            }
                            setSelected={(val) => {
                              let data = props?.filterMapping.map(
                                (itm, idx) => {
                                  if (idx === props?.activeTab) {
                                    return {
                                      ...itm,
                                      criteria_name: val,
                                    };
                                  } else {
                                    return itm;
                                  }
                                },
                              );
                              props?.setFilterMapping(data);
                            }}
                            type="small"
                            showSearch={false}
                            placeholder="Select"
                            searchPlaceholder=""
                            disabled={props?.activeTab !== index}
                          />
                        </div>
                      </div>

                      <div
                        style={{
                          display:
                            filter.column_name &&
                            filter.column_name !== "" &&
                            filter.column_name !== "Confidential transaction"
                              ? "flex"
                              : "none",
                        }}
                        className="flex flex-grow-1 flex-col justify-end gap-y-gap-xs w-full Qmd:w-width-sm-1-3"
                      >
                        {renderField(filter, index)}
                      </div>
                    </div>
                    <div
                      className={`${
                        (props?.filterMapping.every((itm) => {
                          return itm.active === false;
                        }) &&
                          selectedColumns &&
                          selectedColumns.length > 0) ||
                        props?.activeTab === index
                          ? "cursor-pointer"
                          : "cursor-default opacity-60 pointer-events-none"
                      } w-full flex flex-row justify-end  gap-x-gap-md `}
                    >
                      <PrimaryButton
                        enabledBgColor=""
                        btnText="Clear"
                        outLineColor="var(--text-primary)"
                        enabledTextColor="var(--text-primary)"
                        handleFunction={() => {
                          setColumnState(
                            props?.filterMapping[index].column_name,
                          );
                          let data = props?.filterMapping.map((itm, idx) => {
                            if (idx === index) {
                              return {
                                column_name: "",
                                criteria_name: "",
                                input_value: "",
                                active: true,
                              };
                            } else {
                              return itm;
                            }
                          });
                          props?.setActiveTab(index);
                          props?.setFilterMapping(data);

                          setColumnState("");
                        }}
                        hoverOption="white"
                        isDisabled={
                          props?.activeTab !== index &&
                          !(
                            props?.filterMapping.every((itm) => {
                              return itm.active === false;
                            }) &&
                            selectedColumns &&
                            selectedColumns.length > 0
                          )
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
        <div className="h-pagination-height mb-margin-lg"></div>
      </div>
    </>
  );
};

export default MisCreateFilter;
